module.exports = __webpack_public_path__ + "static/6th-587f1024be63c2900b7944fec99fd7a2.png";